// ======================================================================
// File Name       : RoleManagementFunction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../constants/AuthorityConstant';

const RoleManagementFunction = ({ label, name, value, notRegisterEdit, notReference, isDisabled, onChange }) => (
  <Form.Group className="form-info">
    <Col sm={3} as={Form.Label}>{label}</Col>
    {!notRegisterEdit && (
      <Col lg={2} sm={3} className="padding-top-10">
        <Form.Check
          type='radio'
          inline
          className="padding-top-clear"
          name={name}
          id={`${name}-${MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}`}
          value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
          checked={value === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
          onChange={onChange}
          disabled={isDisabled}
          label='全て可能'></Form.Check>
      </Col>
    )}
    {!notReference && (
      <Col lg={2} sm={3} className="padding-top-10">
        <Form.Check
          type='radio'
          inline
          className="padding-top-clear"
          name={name}
          id={`${name}-${MANAGEMENT_AUTHORITY_TYPE.REFERENCE}`}
          value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
          checked={value === MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
          onChange={onChange}
          disabled={isDisabled}
          label={name === 'scoringManagementAuthority' ? '採点のみ' : '参照のみ'}>
        </Form.Check>
      </Col>
    )}
  </Form.Group>
);

export default RoleManagementFunction;
